import { useWorkspace } from '@/features/workspaces/hooks';
import { IconButton } from '@/lib/Buttons';
import { DownloadIcon } from '@/lib/Icons';
import { axiosClient } from '@/services/axiosClient';
import { downloadFile } from '@/utils/downloadFile';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

type DownloadAudienceButtonProps = {
  audienceId: string;
};

export const DownloadAudienceButton: FC<DownloadAudienceButtonProps> = ({ audienceId }) => {
  const { t } = useTranslation('audience_details');
  const workspace = useWorkspace();
  const [isLoading, setIsLoading] = useState(false);

  const onClick = async () => {
    const fileName = `${audienceId}.csv`;

    try {
      setIsLoading(true);
      await downloadFile(async () => {
        const response = await axiosClient({
          url: `/v1/workspaces/${workspace.id}/audiences/${audienceId}/extraction/download`,
          method: 'GET',
          responseType: 'blob',
        });

        return response;
      }, fileName);
    } finally {
      setIsLoading(false);
    }
  };

  return <IconButton intent='secondary' isLoading={isLoading} onClick={onClick} text={t('sources_and_rules.downloadNow')} leadingIcon={<DownloadIcon />} />;
};
